module.exports = __webpack_public_path__ + "static/crosschurch-e56247793ec7a0374090fea334bc6731.png";